import { BoxList as _BoxList} from './BoxList';
import { LabeledList as _LabeledList } from './LabeledList';
import { Profile as _Profile} from './Profile';
import { LargeNumber as _LargeNumber} from './LargeNumber';
import { LargeButton as _LargeButton} from './LargeButton';
import { Link as _Link} from './Link';
import { FAQ as _FAQ} from './FAQ';
import { LinkedSVG as _LinkedSVG } from './LinkedSVG';
import { PrizeItem as _PrizeItem } from './PrizeItem';
import { PrizeList as _PrizeList } from './PrizeList';
import { DivisionList as _DivisionList } from './DivisionList';
import { ScheduleList as _ScheduleList } from './ScheduleList';
import { FileLink as _FileLink } from './FileLink';

export namespace Components
{
	export const BoxList = _BoxList;
	export const LabeledList = _LabeledList;
	export const Profile = _Profile;
	export const LargeNumber = _LargeNumber;
	export const LargeButton = _LargeButton;
	export const Link = _Link;
	export const FAQ = _FAQ;
	export const LinkedSVG = _LinkedSVG;
  export const PrizeItem = _PrizeItem;
  export const PrizeList = _PrizeList;
  export const DivisionList = _DivisionList;
  export const ScheduleList = _ScheduleList;
  export const FileLink = _FileLink;
}